import Connection from './connection'
import PaginatedStore from './paginated_store'

export default class ResellerMembersStore extends PaginatedStore {

  constructor(scope) {
    super(new Connection('resellers', scope))
  }

}



// WEBPACK FOOTER //
// client/stores/resellers.js